var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1741745439188,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2764,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M898.048 256H441.344C386.048 256 366.08 105.472 283.648 102.4H125.952A75.264 75.264 0 0 0 51.2 177.152v669.696A75.264 75.264 0 0 0 125.952 921.6h772.096A75.264 75.264 0 0 0 972.8 846.848V330.752A75.264 75.264 0 0 0 898.048 256z m-187.392 349.696a25.6 25.6 0 0 1-35.84 2.56L537.6 491.008v302.592a25.6 25.6 0 0 1-51.2 0V491.008l-136.704 117.248a25.6 25.6 0 0 1-33.28-38.912l179.2-153.6a25.6 25.6 0 0 1 33.28 0l179.2 153.6a25.6 25.6 0 0 1 2.56 36.352z",
    "p-id": 2765,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.29982c47c04920044caed3b80f55e8d1.svg";
export { ForwardRef as ReactComponent };